import React from 'react'
import PropTypes from 'prop-types'

import { theme } from '../../Assets/Styles/theme'
import { StarRatingStyled } from './style'

const buildStarFilling = (score, max, step) => {
  return Array.apply(null, Array(max)).map((v, index) => {
    const idx = index + 1
    const scr = parseFloat(score) || 0

    if (idx <= scr) return 100
    if (idx - step <= scr) return step * 100
    return 0
  })
}

const Star = ({ index, fill }) => (
  <svg viewBox="0 0 15 15">
    <defs>
      <linearGradient
        id={`star-gradient-${index}`}
        x1="0%"
        y1="0%"
        x2="100%"
        y2="0%"
      >
        <stop offset={`${fill}%`} style={{ stopColor: theme.colors.primary }} />
        <stop
          offset={`${fill}%`}
          style={{ stopColor: theme.colors.athensGray2 }}
        />
      </linearGradient>
    </defs>
    <polygon
      fill={`url(#star-gradient-${index})`}
      points="7.5 12.4376941 2.86474508 15 3.75 9.57294902 -6.38933351e-14 5.72949017 5.18237254 4.9376941 7.5 0 9.81762746 4.9376941 15 5.72949017 11.25 9.57294902 12.1352549 15"
    />
  </svg>
)

Star.propType = {
  index: PropTypes.number.isRequired,
  fill: PropTypes.number.isRequired,
}

const StarRating = ({ uniqueId, score, max, step, key }) => {
  const starFilling = buildStarFilling(score, max, step)
  return (
    <StarRatingStyled key={uniqueId}>
      {starFilling.map((filling, index) => {
        return (
          <Star
            index={uniqueId + '-' + index}
            key={uniqueId + '-' + index}
            fill={filling}
          />
        )
      })}
    </StarRatingStyled>
  )
}

StarRating.propType = {
  id: PropTypes.string.isRequired,
  score: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
}

StarRating.defaultProps = {
  score: 0,
  max: 5,
  step: 0.5,
}

export { StarRating }



// WEBPACK FOOTER //
// ./src/Components/StarRating/index.js